module.exports = __webpack_public_path__ + "img/edge_divers_bus.3216c301.svg";